import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import React from 'react'
import { VelvetSDK } from 'sdk'

interface SubscriberAgreementProps {
  scrollRef: React.LegacyRef<HTMLDivElement>
  onMouseEnter: () => void
  onKeyDown: React.KeyboardEventHandler<HTMLDivElement> | undefined
  focusOnLeft: string
}

const SubscriberAgreement = ({ scrollRef, onKeyDown, focusOnLeft, onMouseEnter }: SubscriberAgreementProps) => {
  const V = VelvetSDK.Vocabulary.vocabulary

  return (
    <div
      id="legal-text"
      className="legal-content-text-item focusable"
      data-sn-left={focusOnLeft}
      tabIndex={-1}
      ref={scrollRef}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
    >
      <div className="legal-content-text-template">
        <div className="legal-content-text-template-title">{V.legalSubscriberAgreementTitle}</div>
        <div className="legal-content-text-template-description">
          <Text tag={TextTag.P} className="policy-introduction">
            {V.subscriberAgreementPolicyText_1}
          </Text>
          <>
            <Text tag={TextTag.P} className="policy-title">
              {V.subscriberAgreementPolicyText_2}
            </Text>
            <ul>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_3}
              </Text>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_4}
              </Text>
            </ul>
          </>
          <>
            <Text tag={TextTag.P} className="policy-title">
              {V.subscriberAgreementPolicyText_5}
            </Text>
            <ul>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_6}
              </Text>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_7}
              </Text>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_8}
              </Text>
            </ul>
          </>
          <>
            <Text tag={TextTag.P} className="policy-title">
              {V.subscriberAgreementPolicyText_9}
            </Text>
            <ul>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_10}
              </Text>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_11}
              </Text>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_12}
              </Text>
            </ul>
          </>
          <>
            <Text tag={TextTag.P} className="policy-title">
              {V.subscriberAgreementPolicyText_13}
            </Text>
            <ul>
              <Text tag={TextTag.LI} className="policy-title">
                {V.subscriberAgreementPolicyText_14}
              </Text>
            </ul>
          </>
        </div>
      </div>
    </div>
  )
}

export default SubscriberAgreement
